export default __webpack_public_path__ + "static/media/business.c68c9bef.svg";